import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-videos-page',
  templateUrl: './videos-page.component.html',
  styleUrls: ['./videos-page.component.css']
})
export class VideosPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
